import { render, staticRenderFns } from "./PriceModeToggle.vue?vue&type=template&id=4024f128&scoped=true"
import script from "./PriceModeToggle.vue?vue&type=script&lang=js"
export * from "./PriceModeToggle.vue?vue&type=script&lang=js"
import style0 from "./PriceModeToggle.vue?vue&type=style&index=0&id=4024f128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024f128",
  null
  
)

export default component.exports